import React, { useState, useReducer, useEffect, useRef } from 'react';
import { message, Modal, Table } from 'antd';
import { Checkbox, InfoBox, Button, Input } from 'components';
import { CSVLink } from 'react-csv';
import ExportFileIcon from 'assests/icons/export-file.icon';
import BanIcon from 'assests/icons/ban.icon';

import 'components/BlackList/black-list.less';
import 'components/GuildePage/guide-page.less';
import 'components/Checkbox/checkbox.less';
import SearchIcon from 'assests/icons/search.icon';
import { useSelector } from 'react-redux';
import {
  getBlackListOptIn,
  addOptOut,
  exportOptIn,
} from 'services/blacklist.service';
import { customMessages } from 'utils';

const OptInTable = () => {
  const exportRefLink = useRef(null);
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [addBlackListModal, setAddBlackListModal] = useState(false);
  const [arrayList, setArrayList] = useState([]);
  const auth = useSelector((state) => state.auth);

  const onInputChange = (value) => {
    const inputValue = value.toUpperCase();
    // const filteredArray = data.filter( (item, index) => {
    //   return item.phone.toUpperCase().indexOf(inputValue) > -1
    // })
    // setArrayList(filteredArray)
  };

  function fetchData() {
    getBlackListOptIn()
      .then((result) => {
        setArrayList(result.consentStatusInList);
      })
      .catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  function onAddOptOut(data) {
    addOptOut({ ids: data })
      .then((result) => {
        fetchData();
      })
      .catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
    setSelectedRow([]);
  }

  function onExport() {
    exportRefLink.current.link.click();
  }

  useEffect(() => {
    fetchData();
  }, []);

  const columnsV2 = [
    {
      title: '',
      dataIndex: 'check',
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setSelectedRow(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setSelectedRow([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setSelectedRow((prevArray) => [...prevArray, selectedRows]);
                  } else {
                    setSelectedRow(
                      selectedRow.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Telefon No',
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'msisdn',
        },
      ],
    },
    {
      title: 'Çıkarılma Tarihi',
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {selectedRow.length > 0 ? (
                <>
                  <span>{selectedRow.length} Kişi Seçildi</span>
                  <div className="group-actions">
                    <button
                      type="button"
                      onClick={() => {
                        onAddOptOut(selectedRow.map((item) => item.msisdn));
                      }}
                    >
                      <BanIcon />
                      <span>Kara Listeye Ekle</span>
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          ),
          dataIndex: 'lastOptoutDate',
          render: (text, record) => (
            <>
              <span>{text}</span>
              {/* <div className="row-edit">
                <button type="button" onClick={()=> onAddOptOut([record.msisdn])}><BanIcon /></button>
              </div> */}
            </>
          ),
        },
      ],
    },
  ];

  const headers = [
    { label: 'Telefon Numarası', key: 'msisdn' },
    { label: 'Kara Listeye Eklenme Tarihi', key: 'lastOptoutDate' },
    { label: 'Kara Listeden Çıkarılma Tarihi', key: 'lastOptinDate' },
  ];

  return (
    <div className="group-members">
      <div className="group-members__header">
        <strong className="group-members__title">Kara Listeden Çıkanlar</strong>
        <div className="group-actions">
          <button
            onClick={() => {
              onExport();
            }}
            type="button"
          >
            <ExportFileIcon />
            <span>Dışa Aktar</span>
          </button>
          <CSVLink
            data={arrayList}
            headers={headers}
            ref={exportRefLink}
            filename={'karaliste-cikarilanlar.xls'}
            separator={';'}
            target="_blank"
          >
            {' '}
          </CSVLink>
        </div>
      </div>
      <InfoBox
        type="warning"
        content={
          <p>
            Bu listede daha önceden kara listenize eklenmiş fakat sonra sizin
            tarafınızdan kara listeden çıkartılmış numaraları görmektesiniz.
            Listede yer alan numaralara SMS gönderimi yapabilirsiniz.
            İstediğiniz numaraları tekrardan kara listeye ekleyebilirsiniz.
          </p>
        }
      />
      <div className="group-members__search">
        <Input
          prefix={<SearchIcon />}
          placeholder="Grup İçerisinde Ara..."
          autoComplete="off"
          style={{ width: '100%' }}
          onChange={(e) => onInputChange(e.target.value)}
        />
      </div>
      <Table
        rowKey="msisdn"
        columns={columnsV2}
        scroll={{ y: 610 }}
        dataSource={arrayList}
        className="table--guide table--black-list"
        pagination={{ total: arrayList.length, position: ['bottomCenter'] }}
      />
      <Modal
        title="Kara Listeye Ekle"
        visible={addBlackListModal}
        onCancel={() => setAddBlackListModal(false)}
        footer={null}
      >
        <p>
          Seçtiğiniz {selectedRow.length} kayıt kara listeye eklenecektir. Bu
          kayıtlara “Kara Listedeki Kullanıcılar” bölümünden ulaşabilirsiniz.
        </p>
        <div className="modal-action">
          <Button
            shape="round"
            type="ghost"
            onClick={() => {
              onAddOptOut(selectedRow.map((item) => item.msisdn));
              setAddBlackListModal(false);
            }}
          >
            Vazgeç
          </Button>
          <Button
            key="confirm"
            type="primary"
            onClick={() => setAddBlackListModal(false)}
          >
            Çıkar
          </Button>
        </div>
      </Modal>
    </div>
  );
};
export default OptInTable;
